import { useEffect } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import type { TAppProps } from '@crehana/next';

import { AuthSEO } from '@/shared/components';

import { LoginForm as LoginFormV2 } from './components';
import B2CLayout from './components/B2CLayout';
import { IAppProps } from './types';

const App: React.FC<React.PropsWithChildren<TAppProps<IAppProps>>> = ({
  featureFlags,
}) => {
  const { logEvent } = useAmplitude();

  useEffect(() => {
    logEvent({
      event: 'Render Signin',
      data: {
        ...getSourceEventParams(),
        Type: 'URL',
      },
    });
  }, []);

  return (
    <B2CLayout>
      <AuthSEO />
      <LoginFormV2 featureFlags={featureFlags} />
    </B2CLayout>
  );
};

export default App;
